export default __webpack_public_path__ + "locales/uk-UA/ResetApplicationDialog.json?hash=84309f2ba4f7422eb7997044c949ea10";